import { jsx as _jsx } from "react/jsx-runtime";
import { Button as HeadlessButton } from "@headlessui/react";
import React from "react";
import clsx from "clsx";
import { TouchTarget } from "./Button";
import { Link } from "./Link";
import { elementTheme, subtleElementTheme } from "../theme/colors";
export function Badge({ color = "zinc", variant = "default", className, ...props }) {
    const theme = variant === "subtle" ? subtleElementTheme : elementTheme;
    return /*#__PURE__*/ _jsx("span", {
        ...props,
        className: clsx(className, "inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 font-normal text-sm/5 forced-colors:outline", theme[color])
    });
}
export const BadgeButton = /*#__PURE__*/ React.forwardRef(function BadgeButton({ color = "zinc", variant = "default", className, children, ...props }, ref) {
    let classes = clsx(className, "group relative inline-flex rounded-md focus:outline-none data-[focus]:outline data-[focus]:outline-2 data-[focus]:outline-offset-2 data-[focus]:outline-blue-500");
    return "href" in props ? /*#__PURE__*/ _jsx(Link, {
        ...props,
        className: classes,
        ref: ref,
        children: /*#__PURE__*/ _jsx(TouchTarget, {
            children: /*#__PURE__*/ _jsx(Badge, {
                color: color,
                variant: variant,
                children: children
            })
        })
    }) : /*#__PURE__*/ _jsx(HeadlessButton, {
        ...props,
        className: classes,
        ref: ref,
        children: /*#__PURE__*/ _jsx(TouchTarget, {
            children: /*#__PURE__*/ _jsx(Badge, {
                color: color,
                variant: variant,
                children: children
            })
        })
    });
});
